<msc-froala [(content)]="content" (onUpdate)="update()"></msc-froala>
